import { render, staticRenderFns } from "./ManagePromos.vue?vue&type=template&id=3b283682&scoped=true&"
import script from "./ManagePromos.vue?vue&type=script&lang=js&"
export * from "./ManagePromos.vue?vue&type=script&lang=js&"
import style0 from "./ManagePromos.vue?vue&type=style&index=0&id=3b283682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b283682",
  null
  
)

export default component.exports